module.exports = __webpack_public_path__ + "img/a11y-large-text-1_en.f67c2dd.jpg";